import { v4 as uuidV4 } from "uuid"

import { DEVICE_ID_COOKIE, DEVICE_ID_MAX_AGE_SECONDS } from "@/platform/api/constants"
import { readCookie, setCookie } from "@/platform/browser/cookies"

export const deviceIdClient = (): string | null => {
  if (typeof window === "undefined") return null

  const existing = readCookie(DEVICE_ID_COOKIE)
  if (existing) return existing

  const minted = uuidV4()
  setCookie(DEVICE_ID_COOKIE, minted, { maxAgeSeconds: DEVICE_ID_MAX_AGE_SECONDS, sameSite: "Lax" })

  return minted
}
